import RibbonButton, { RibbonButtonState } from './RibbonButton';
import strings from 'owa-strings/owa-mail-strings';
import { toggleBlockQuote } from 'roosterjs-editor-api';

const blockquote: RibbonButton = {
    key: 'blockquote',
    title: () => strings.blockQuote,
    imageSrc: require('../svg/blockquote.svg'),
    onExecute: plugin =>
        toggleBlockQuote(plugin.getEditor(), element => {
            element.style.borderLeft = '3px solid';
            element.style.borderColor = '#C8C8C8';
            element.style.paddingLeft = '1ex';
            element.style.marginLeft = '0.8ex';
            element.style.color = '#666666';
        }),
    buttonState: formatState =>
        formatState.isBlockQuote ? RibbonButtonState.Checked : RibbonButtonState.Normal,
};

export default blockquote;
